(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["banner-new-home-page"] && !window.DesignMode) return;
  try {
    
  	//banner slider
	$(".bannerSlider").slick({
	    dots: false
	    , autoplay: true
	    , infinite: true
	    , dots: false
	    , slidesToShow: 1
	    , slideswToScroll: 1
	    , arrows: false
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-new-home"]) return;
  try {
    
  	$(".bannerSlider").slick({
	    dots: false
	    , autoplay: true
	    , infinite: true
	    , dots: false
	    , slidesToShow: 1
	    , slideswToScroll: 1
	    , arrows: false
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-updated"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $('.carousels').slick({
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
     autoplay: false,
    arrows:false,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         autoplay: false,

      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,

      }
    },  {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
      }
    }]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Green-Arrivals-Products"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $('.carouse').slick({
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
     autoplay: true,
    arrows: true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,

      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        

      }
    },  {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
      }
    }]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-home-banner"]) return;
  try {
    
  $(document).ready(function(){
  $('.carousels').slick({
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
     autoplay: false,
    arrows:false,
    dots: true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         autoplay: false,

      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,

      }
    },  {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
      }
    }]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-home-specific-collection-slider"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
  console.log('ready!');
$('.section-collection-slider-left .right_arrow').click(function(){
    $('.main-collection-slider1 .slick-next').click();
});
  $('.section-collection-slider-left .left_arrow').click(function(){
    $('.main-collection-slider1 .slick-prev').click();
});
  // Main Collections slider
  $('.main-collection-slider1').slick({
    dots: false,
    infinite: true,
    speed: 300,
    rtl: false,
    loop: true,
    slidesToShow: 4.5,

    // adaptiveHeight: true,
      responsive: [
        {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: -1,
          infinite: true,
         dots: false
        }
      },
         {
        breakpoint: 1370,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
         {
        breakpoint: 800,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll:1,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-home-testimonials"]) return;
  try {
    
  $(document).ready(function () {  console.log("ready!");
$('.testimonial_right_arrow').click(function(){
    $('.testimonials .slick-next').click();
});
  $('.testimonial_left_arrow').click(function(){
    $('.testimonials .slick-prev').click();
});
    $('.testimonials').slick({
    dots: false,
    infinite: true,
    speed: 300,
     arrows: true,
    slidesToShow: 1,

    // adaptiveHeight: true,
      responsive: [
         {
        breakpoint: 1170,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll:1,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-tabs"]) return;
  try {
    
 
$(document).ready(function(){
 $('.carousel').slick({
   speed: 500,
   slidesToShow: 5,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   dots:false,
   arrows:false,
   centerMode: true,
   infinite: true,
   // variableWidth: true,
   responsive: [{
     breakpoint: 1024,
     settings: {
       slidesToShow: 1,
       slidesToScroll: 1,
       // centerMode: true,

     }

   }, {
     breakpoint: 800,
     settings: {
       slidesToShow: 1,
       slidesToScroll: 1,
       dots: true,
       infinite: true,

     }
   },  {
     breakpoint: 480,
     settings: {
       slidesToShow: 1,
       slidesToScroll: 1,
       dots: true,
       infinite: true,
       autoplay: true,
       autoplaySpeed: 2000,
     }
   },
     {
     breakpoint: 300,
     settings: {
       slidesToShow: 1,
       slidesToScroll: 1,
       dots: true,
       infinite: true,
       autoplay: true,
       autoplaySpeed: 2000,
     }
   }          ]
 });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recomend"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $('.carouse').slick({
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
     autoplay: false,
    arrows:false,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
         autoplay: false,

      }

    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        

      }
    }, 
                 {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        

      }
    },{
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
      }
    }]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["right-image-collection"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
  console.log('ready!');
$('.section-collection-slider-right .right_arrow').click(function(){
    $('.main-collection-slider2 .slick-next').click();
});
  $('.section-collection-slider-right .left_arrow').click(function(){
    $('.main-collection-slider2 .slick-prev').click();
});
  // Main Collections slider
  $('.main-collection-slider2').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3.5,

    // adaptiveHeight: true,
      responsive:[
         {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
         {
        breakpoint: 1370,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
         {
        breakpoint: 800,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
         dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll:1,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection-second"] && !window.DesignMode) return;
  try {
    

  for (let i = 1; i <5 ; i++) {
    $('#tabslistitems'+i).click(function(){
       $('#new-tabs2 .tabs').removeClass('active');
         $('#new-tabs2 #tabslistitems'+i).addClass('active');
    $('.tabs_contentt').css({"opacity":"0","position":"absolute"});
      $('#tab_content_secc'+i).css({"opacity":"1","position":"relative"});

    });}
      $(document).ready(function(){
        setTimeout(function() { 
        $('.tabs_contentt').not(':first-child').css({"opacity":"0","position":"absolute"});
    }, 2000);
      
  $('.carousetabs2').slick({
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
     autoplay: false,
    arrows:true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
         autoplay: false,

      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:true,
        infinite: true,
        

      }
    },  {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        arrows:true,
        autoplaySpeed: 2000,
      }
    }]
  });
});
 
  
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !window.DesignMode) return;
  try {
    
    $('.left-icon').click(function(){
     $('.slick-prev').click();
   });
  $('.right-icon').click(function(){
     $('.slick-next').click();
   });
   $('button.slick-prev.slick-arrow').html('hellow'); 
  for (let i = 1; i <5 ; i++) {
    $('#tabslistitem'+i).click(function(){
    
       $('#new-tabs1 .tabs').removeClass('active');
         $('#tabslistitem'+i).addClass('active');
      // $('.tabs_content').hide();
      // $('#tab_content_sec'+i)show();
      $('.tabs_content').css({"opacity":"0","position":"absolute","z-index":"-9999"});
      $('#tab_content_sec'+i).css({"opacity":"1","position":"relative","z-index":"2"});
    });}
  
    $(document).ready(function(){
        setTimeout(function() { 
        $('.tabs_content').not(':first-child').css({"opacity":"0","position":"absolute","z-index":"-9999"});
    }, 2000);
      
  $('.carousetabs').slick({
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
     autoplay: false,
    arrows:true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
         autoplay: false,
      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:true, 
        infinite: true,


      }
    },  {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        arrows:true, 
        autoplaySpeed: 2000,
      }
    }]
  });
});
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    
  $('.carousel-inner .carousel-item:first-child').addClass('active');

  } catch(e) { console.error(e); }
})();

})();
